import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import { useMemo, type ReactNode } from 'react';
import { createI18n } from '@et/ui';
import { AccountProvider } from '../features/account/account.js';
import type { Locale } from '@et/schema';

/** Conteudo imutavel dentro de uma versao: nunca revalidar por tempo. */
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
        gcTime: 24 * 60 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });

export function Providers({ locale, client, children }: {
  readonly locale: Locale;
  readonly client: QueryClient;
  readonly children: ReactNode;
}) {
  const i18n = useMemo(() => createI18n(locale), [locale]);
  return (
    <QueryClientProvider client={client}>
      <I18nextProvider i18n={i18n}>
        <AccountProvider>{children}</AccountProvider>
      </I18nextProvider>
    </QueryClientProvider>
  );
}
